// src/components/RingChart.js — SVG circular progress ring
import React from "react";

export default function RingChart({ pct = 0, size = 52, strokeWidth = 5 }) {
  const r    = (size - strokeWidth * 2) / 2;
  const cx   = size / 2;
  const circ = 2 * Math.PI * r;
  const dash = circ * (Math.min(pct, 100) / 100);

  const color =
    pct >= 75 ? "#16a34a" :
    pct >= 50 ? "#d97706" :
    pct >= 40 ? "#d97706" : "#dc2626";

  return (
    <div style={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center", width: size, height: size }}>
      <svg
        width={size} height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: "rotate(-90deg)", position: "absolute" }}
      >
        {/* Track */}
        <circle cx={cx} cy={cx} r={r} fill="none" stroke="#ece9e2" strokeWidth={strokeWidth} />
        {/* Fill */}
        <circle
          cx={cx} cy={cx} r={r}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${dash} ${circ - dash}`}
          strokeLinecap="round"
        />
      </svg>
      <span style={{ position: "absolute", fontSize: size < 60 ? 10 : 14, fontWeight: 700, color }}>
        {pct}%
      </span>
    </div>
  );
}
